export type Language = 'fr' | 'en' | 'ar';

export const SUPPORTED_LANGUAGES: Language[] = ['fr', 'en', 'ar'];

export const translations = {
  fr: {
    // Header
    nav: {
      book: 'Réserver',
      track: 'Suivre',
      pay: 'Payer',
      rate: 'Évaluer',
      platform: 'Plateforme',
      marketplace: 'Marketplace',
      services: 'Services',
      delivery: 'Livraison',
      rental: 'Location',
      insurance: 'Assurance & Finance',
      projects: 'Projets',
      joinPro: 'Devenir Pro',
      adminPanel: 'Panneau Admin',
      professionalDashboard: 'Tableau Pro',
      downloadApp: 'Télécharger Dispatch',
      download: 'Télécharger',
    },
    // Hero
    hero: {
      badge: 'Disponible dans 40+ villes · 12 000+ pros',
      headline1: 'Du robinet',
      headline2: 'qui fuit au',
      headline3: 'problème résolu.',
      subtitle: "Trois clics entre le problème et le rendez-vous confirmé. Plombiers, électriciens et agents de nettoyage agréés — disponibles aujourd'hui.",
      appStore: 'App Store',
      googlePlay: 'Google Play',
      stat1n: '< 60s',
      stat1l: 'temps de réservation',
      stat2n: '4.9★',
      stat2l: 'note moyenne pro',
      stat3n: 'Gratuit',
      stat3l: 'sans frais de service',
      bookingConfirmed: 'Réservation Confirmée',
      taskId: 'Tâche #DIS-20260227-4891',
      enRoute: 'en route',
      plumber: 'Plombier Agréé',
      missions: 'missions',
      eta: 'ETA',
      service: 'Service',
      serviceVal: 'Plomberie',
      slot: 'Créneau',
      slotVal: "Aujourd'hui, 14h–16h",
      address: 'Adresse',
      addressVal: '847 W Monroe, Chicago',
      cost: 'Coût Est.',
      costVal: '95–140 €',
      terminalTitle: 'dispatch.js — moteur de réservation',
    },
    // Stats
    stats: [
      { value: '2,4M+', label: 'Missions Réalisées' },
      { value: '< 60s', label: 'Temps de Réservation' },
      { value: '98%', label: 'Ponctualité' },
      { value: '12 000+', label: 'Pros Agréés' },
      { value: '4.9 ★', label: 'Note Moyenne Pro' },
      { value: '40+', label: 'Villes Couvertes' },
    ],
    // Book
    book: {
      chip: '01 / Réserver',
      headline1: "L\'ancienne méthode prenait",
      headline2: '40 minutes',
      headline3: 'et 3 messages vocaux.',
      subtitle: "Dispatch vous met en relation avec un pro agréé et vérifié dans votre catégorie — disponible aujourd'hui — avant que vous finissiez votre café.",
      cta: 'Réservez votre première mission gratuitement →',
      appHeader: 'De quoi avez-vous besoin ?',
      searchPlaceholder: "robinet qui fuit sous l\'évier…",
      available: '14 plombiers disponibles maintenant',
      earliest: "Plus tôt : Aujourd\'hui à 13h00",
      bookBtn: 'Réserver →',
      chips: [
        'Mise en relation instantanée',
        'Disponibilité en temps réel',
        'Vérification des licences',
        'Vérification des antécédents',
        'Créneaux le jour même',
        'Catégorie : Plomberie · Électricité · CVC · Nettoyage',
        'IA de planification intelligente',
        'Sans engagement minimum',
      ],
      services: [
        { icon: '🔧', name: 'Plomberie', count: '840 pros' },
        { icon: '⚡', name: 'Électricité', count: '620 pros' },
        { icon: '❄️', name: 'CVC', count: '390 pros' },
        { icon: '🧹', name: 'Nettoyage', count: '1 200 pros' },
        { icon: '🪟', name: 'Vitres', count: '210 pros' },
        { icon: '🔒', name: 'Serrurier', count: '180 pros' },
      ],
    },
    // Track
    track: {
      chip: '02 / Suivre',
      headline1: 'Fini les',
      headline2: '« ils ont dit 14h »',
      headline3: 'sans nouvelles.',
      subtitle: "Suivi GPS en direct, ETA précis et notifications push à chaque changement de statut. Vous saurez exactement quand rentrer — à la minute près.",
      cta: 'Suivez votre prochaine mission →',
      eta: 'ETA',
      enRoute: 'Marcus est en route',
      notifTitle: 'Dispatch',
      notifBody: "Marcus est à 3 rues. Ouvrez votre porte ! 🔧",
      notifTime: 'maintenant',
      testimonial: "« Je gère 8 appartements à Lincoln Park. Dispatch me dit que le plombier arrive dans 6 minutes avant même que mon locataire m\'envoie un message. »",
      testimonialAuthor: '— Priya Nair, Propriétaire · Chicago',
      steps: ['Associé', 'Confirmé', 'En route', 'Arrivé', 'Terminé'],
      chips: [
        'Suivi GPS en direct',
        'Notifications push',
        'Moteur ETA précis',
        'Mises à jour du statut',
        "Confirmation d\'arrivée",
        "Optimisation d\'itinéraire",
      ],
    },
    // Pay
    pay: {
      chip: '03 / Payer',
      headline1: 'Pas de relance de facture.',
      headline2: 'Pas de surprise.',
      headline3: "Pas d\'espèces.",
      subtitle: "Chaque mission se termine par une facture vérifiée par photo que vous approuvez avant qu'un centime ne soit débité. Les reçus arrivent directement par e-mail. Les propriétaires reçoivent des relevés mensuels consolidés.",
      cta: 'Voir la démo de facturation →',
      landlordTitle: 'Pour les propriétaires & gestionnaires',
      landlordBody: "Un tableau de bord. Tous les biens. Chaque facture classée par unité, catégorie et date — prête pour votre comptable.",
      invoiceId: 'Facture #DIS-INV-2891',
      invoiceDate: '27 fév. 2026 · 16h22',
      invoiceStatus: "En attente d\'approbation",
      photoVerif: 'Vérification photo — 3 photos jointes',
      total: 'Total',
      dispute: 'Contester',
      approve: 'Approuver & Payer',
      free: 'Offert',
      chips: [
        'Facturation intégrée',
        'Vérification photo',
        'Reçus numériques',
        'Paiement fractionné',
        'Carte · Apple Pay · Google Pay',
        'Sans espèces',
        'Paiement instantané pro',
        'Exports fiscaux',
      ],
      lineItems: [
        { desc: "Main-d'œuvre — 1,5h à 75€/h", amount: '112,50 €' },
        { desc: 'Cartouche de remplacement (OEM)', amount: '28,00 €' },
        { desc: 'Frais de déplacement', amount: '0,00 €' },
      ],
    },
    // Rate
    rate: {
      chip: '04 / Évaluer',
      headline1: 'Les pros méritent',
      headline2: 'leur prochaine mission',
      headline3: 'sur celle-ci.',
      subtitle: "Chaque mission est évaluée. Chaque avis est vérifié. Les pros sur Dispatch se présentent parce que leur gagne-pain en dépend — pas juste leur week-end.",
      cta: 'Télécharger Dispatch →',
      rateTitle: 'Évaluer Marcus T.',
      rateSubtitle: 'Plomberie · 27 fév. 2026 · Mission #DIS-4891',
      submitBtn: "Soumettre l\'avis",
      submitted: 'Avis soumis !',
      submittedSub: 'Score de Marcus mis à jour : 4.9 ★',
      chips: [
        'Avis bidirectionnels',
        'Avis vérifiés',
        'Responsabilité des pros',
        'Système de score qualité',
        'Résolution des litiges',
        'Système de badges',
      ],
      pros: [
        { badge: 'Pro Élite', role: 'Maître Plombier', tags: ['Rapide', 'Soigné', 'Communicatif'] },
        { badge: 'Très bien noté', role: 'Électricienne Agréée', tags: ['Ponctuelle', 'Rigoureuse', 'Professionnelle'] },
        { badge: 'Étoile Montante', role: 'Technicien CVC', tags: ['Minutieux', 'Compétent', 'Aimable'] },
      ],
    },
    // Testimonials
    testimonials: {
      headline1: 'La liste des tâches du week-end',
      headline2: "n\'est plus une crise.",
      row1: [
        { quote: "J'ai réservé un plombier à 7h, il était à ma porte à 9h. Avant, je passais une heure à appeler partout. Plus jamais.", name: 'Jennifer Okafor', title: 'Propriétaire · Brooklyn, NY' },
        { quote: "Je gère 6 appartements à Logan Square. Dispatch est la seule appli qui fonctionne vraiment quand l\'appartement 4B a une urgence à 23h.", name: 'David Chen', title: 'Propriétaire · Chicago, IL' },
        { quote: "Le suivi en temps réel vaut à lui seul l\'abonnement. Je sais exactement quand quitter le bureau. Fini le \'le technicien sera là entre 12h et 17h\'.", name: 'Aisha Patel', title: 'Propriétaire · Los Angeles, CA' },
        { quote: "En tant que gestionnaire de 40+ appartements, la facturation consolidée seule me fait gagner 3 heures par mois. Les pros sont vraiment sérieux.", name: 'Marcus Webb', title: 'Gestionnaire immobilier · New York, NY' },
      ],
      row2: [
        { quote: "Mon locataire a appelé pour la clim à 8h vendredi. J\'avais un technicien CVC confirmé avant 8h05. C\'est tout le concept.", name: 'Keisha Thompson', title: 'Propriétaire · Atlanta, GA' },
        { quote: "La vérification photo avant paiement est géniale. J'ai déjà été déçu par un travail bâclé. Maintenant je vois avant de payer.", name: 'Tom Kowalski', title: 'Propriétaire · Chicago, IL' },
        { quote: "Trois propriétés, un seul téléphone. Avant j'avais un dossier de cartes de visite d'artisans. Maintenant j'ai Dispatch.", name: 'Fatima Al-Hassan', title: 'Investisseur immobilier · Houston, TX' },
        { quote: "Un électricien est arrivé en 45 minutes un samedi. Licence vérifiée, antécédents contrôlés. Mon ancien prestataire ne répondait jamais le week-end.", name: 'Ryan Nguyen', title: 'Propriétaire · San Francisco, CA' },
      ],
    },
    // Download
    download: {
      badge: 'Gratuit · Sans carte bancaire · Sans inscription',
      headline1: 'Fermez les onglets.',
      headline2: 'Téléchargez Dispatch.',
      subtitle: "Une appli. Tous les corps de métier agréés. Disponible aujourd'hui dans 40+ villes. Le téléchargement suffit — aucun compte requis pour votre première réservation.",
      appStoreLabel: 'Télécharger sur',
      appStoreName: 'App Store',
      googlePlayLabel: 'Disponible sur',
      googlePlayName: 'Google Play',
      or: 'ou',
      smsLabel: 'Recevoir le lien par SMS',
      smsPlaceholder: '+33 6 00 00 00 00',
      smsSend: 'Envoyer',
      smsSent: '✓ Envoyé !',
      smsDisclaimer: 'Numéros français uniquement · Pas de spam · Un seul message',
      trust: [
        { icon: '🔒', text: 'SOC 2 Type II' },
        { icon: '✓', text: 'Sans carte bancaire' },
        { icon: '⭐', text: 'Note 4.9 App Store' },
        { icon: '🏆', text: '#1 Appli Services à domicile' },
      ],
    },
    // Footer
    footer: {
      book: 'Réserver',
      track: 'Suivre',
      pay: 'Payer',
      rate: 'Évaluer',
      downloadLink: 'Télécharger',
      copyright: '© 2026 Dispatch Technologies, Inc.',
      privacy: 'Confidentialité',
      terms: 'Conditions',
      support: 'Assistance',
    },
    // Mobile CTA
    mobileCta: {
      appStore: 'App Store',
      googlePlay: 'Google Play',
    },
    // Marketplace
    marketplace: {
      chip: '🛠️ Marketplace de Services',
      headline1: 'Trouvez des Professionnels',
      headline2: 'de Confiance',
      headline3: 'Près de Vous, Maintenant',
      subtitle: 'Parcourez des plombiers, électriciens, agents de nettoyage et plus — avec de vraies notes, disponibilité en direct et réservation instantanée.',
      searchPlaceholder: 'Rechercher par nom, spécialité ou lieu…',
      categories: {
        all: 'Tous les Services',
        plumbing: 'Plomberie',
        electrical: 'Électricité',
        cleaning: 'Nettoyage',
        hvac: 'CVC',
        carpentry: 'Menuiserie',
        painting: 'Peinture',
        landscaping: 'Jardinage',
        security: 'Sécurité',
      },
      professionalsFound: 'professionnels trouvés',
      inCategory: 'dans',
      availableNow: 'Disponible Maintenant',
      sortTopRated: 'Les Mieux Notés',
      sortAvailable: 'Disponible Maintenant',
      sortExperienced: 'Plus Expérimentés',
      sortPriceLow: 'Prix : Croissant',
      sortPriceHigh: 'Prix : Décroissant',
      available: 'Disponible',
      busy: 'Occupé',
      jobs: 'Missions',
      rate: 'Tarif',
      area: 'Zone',
      bookNow: 'Réserver →',
      noResults: 'Aucun professionnel trouvé',
      noResultsSub: 'Essayez d\'ajuster votre recherche ou vos filtres',
      clearFilters: 'Effacer tous les filtres',
      ctaChip: '🚀 Pour les Professionnels',
      ctaHeadline: 'Développez Votre Activité',
      ctaSubtitle: 'Rejoignez des milliers de professionnels vérifiés sur Dispatch. Obtenez plus de clients, gérez vos réservations et développez votre réputation — tout en un.',
      ctaJoin: 'Rejoindre en tant que Professionnel →',
      ctaLearn: 'En Savoir Plus',
    },
    // Professional Detail
    professionalDetail: {
      backToMarketplace: 'Retour au Marketplace',
      availableNow: 'Disponible Maintenant',
      busy: 'Occupé',
      startingRate: 'tarif de départ',
      reviews: 'avis',
      tabOverview: 'Aperçu',
      tabReviews: 'Avis',
      tabServices: 'Services',
      jobsDone: 'Missions',
      experience: 'Expérience',
      response: 'Réponse',
      serviceArea: 'Zone',
      yrs: 'ans',
      about: 'À propos de',
      serviceHours: 'Horaires de Service',
      closed: 'Fermé',
      servicesPriceNote: 'Services courants proposés — le prix final peut varier selon la portée du travail.',
      bookSession: 'Réserver une Session',
      nextAvailable: 'Prochaine disponibilité :',
      bookingConfirmed: 'Réservation Confirmée !',
      bookAnotherTime: 'Réserver un Autre Créneau',
      quickContact: 'Contact Rapide',
      sendMessage: 'Envoyer un Message',
      requestCallback: 'Demander un Rappel',
      avgResponse: 'Temps de réponse moyen :',
      selectDateTime: 'Sélectionnez une date et une heure',
      bookNowAt: 'Réserver Maintenant —',
      availableTimes: 'Créneaux disponibles —',
      days: {
        Monday: 'Lundi',
        Tuesday: 'Mardi',
        Wednesday: 'Mercredi',
        Thursday: 'Jeudi',
        Friday: 'Vendredi',
        Saturday: 'Samedi',
        Sunday: 'Dimanche',
      },
      months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      dayNames: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    },
    // Booking Confirmation
    bookingConfirmation: {
      headline: 'Réservation Confirmée !',
      subheadline: 'Votre rendez-vous a été enregistré. Vous recevrez une confirmation par e-mail.',
      referenceLabel: 'Référence de réservation',
      copy: 'Copier',
      copied: 'Copié !',
      professionalLabel: 'Votre professionnel',
      reviews: 'avis',
      viewProfile: 'Voir le profil',
      appointmentLabel: 'Détails du rendez-vous',
      serviceType: 'Service',
      dateLabel: 'Date',
      timeLabel: 'Créneau',
      addressLabel: 'Adresse',
      costLabel: 'Récapitulatif des coûts',
      subtotal: 'Sous-total',
      serviceFee: 'Frais de service',
      total: 'Total',
      nextStepsLabel: 'Prochaines étapes',
      step1Title: 'Réservation confirmée',
      step1Desc: 'Votre demande a été enregistrée et le professionnel a été notifié.',
      step2Title: 'Confirmation du professionnel',
      step2Desc: 'Le professionnel confirmera votre rendez-vous dans les 30 minutes.',
      step3Title: 'Rappel la veille',
      step3Desc: 'Vous recevrez un rappel 24h avant votre rendez-vous.',
      step4Title: 'Service effectué',
      step4Desc: 'Après le service, évaluez votre expérience et laissez un avis.',
      contactBtn: 'Contacter le pro',
      rescheduleBtn: 'Reprogrammer',
      contactTitle: 'Contacter Marcus Johnson',
      callNow: 'Appeler',
      sendSms: 'Envoyer un SMS',
      smsLabel: 'Message',
      rescheduleTitle: 'Reprogrammer le rendez-vous',
      rescheduleDesc: 'Choisissez un nouveau créneau sur le profil du professionnel.',
      rescheduleAction: 'Choisir un nouveau créneau →',
      viewDashboard: 'Voir mon tableau de bord',
      browseMore: 'Explorer le marketplace',
    },
  },

  en: {
    nav: {
      book: 'Book',
      track: 'Track',
      pay: 'Pay',
      rate: 'Rate',
      platform: 'Platform',
      marketplace: 'Marketplace',
      services: 'Services',
      delivery: 'Delivery',
      rental: 'Rental',
      insurance: 'Insurance & Finance',
      projects: 'Projects',
      joinPro: 'Join as Pro',
      adminPanel: 'Admin Panel',
      professionalDashboard: 'Pro Dashboard',
      downloadApp: 'Download Dispatch',
      download: 'Download',
    },
    hero: {
      badge: 'Available in 40+ cities · 12,000+ pros',
      headline1: 'From the leaky',
      headline2: 'faucet to the',
      headline3: 'problem solved.',
      subtitle: 'Three clicks between the problem and the confirmed appointment. Licensed plumbers, electricians and cleaning agents — available today.',
      appStore: 'App Store',
      googlePlay: 'Google Play',
      stat1n: '< 60s',
      stat1l: 'booking time',
      stat2n: '4.9★',
      stat2l: 'avg pro rating',
      stat3n: 'Free',
      stat3l: 'no service fees',
      bookingConfirmed: 'Booking Confirmed',
      taskId: 'Task #DIS-20260227-4891',
      enRoute: 'en route',
      plumber: 'Licensed Plumber',
      missions: 'jobs',
      eta: 'ETA',
      service: 'Service',
      serviceVal: 'Plumbing',
      slot: 'Slot',
      slotVal: 'Today, 2pm–4pm',
      address: 'Address',
      addressVal: '847 W Monroe, Chicago',
      cost: 'Est. Cost',
      costVal: '$95–140',
      terminalTitle: 'dispatch.js — booking engine',
    },
    stats: [
      { value: '2.4M+', label: 'Jobs Completed' },
      { value: '< 60s', label: 'Booking Time' },
      { value: '98%', label: 'On-Time Rate' },
      { value: '12,000+', label: 'Licensed Pros' },
      { value: '4.9 ★', label: 'Avg Pro Rating' },
      { value: '40+', label: 'Cities Covered' },
    ],
    book: {
      chip: '01 / Book',
      headline1: 'The old way took',
      headline2: '40 minutes',
      headline3: 'and 3 voicemails.',
      subtitle: 'Dispatch connects you with a licensed, verified pro in your category — available today — before you finish your coffee.',
      cta: 'Book your first job for free →',
      appHeader: 'What do you need?',
      searchPlaceholder: 'leaky faucet under the sink…',
      available: '14 plumbers available now',
      earliest: 'Earliest: Today at 1:00 PM',
      bookBtn: 'Book →',
      chips: [
        'Instant matching',
        'Real-time availability',
        'License verification',
        'Background checks',
        'Same-day slots',
        'Category: Plumbing · Electric · HVAC · Cleaning',
        'Smart scheduling AI',
        'No minimum commitment',
      ],
      services: [
        { icon: '🔧', name: 'Plumbing', count: '840 pros' },
        { icon: '⚡', name: 'Electrical', count: '620 pros' },
        { icon: '❄️', name: 'HVAC', count: '390 pros' },
        { icon: '🧹', name: 'Cleaning', count: '1,200 pros' },
        { icon: '🪟', name: 'Windows', count: '210 pros' },
        { icon: '🔒', name: 'Locksmith', count: '180 pros' },
      ],
    },
    track: {
      chip: '02 / Track',
      headline1: 'No more',
      headline2: '"they said 2pm"',
      headline3: 'with no updates.',
      subtitle: 'Live GPS tracking, precise ETA and push notifications on every status change. You\'ll know exactly when to head home — to the minute.',
      cta: 'Track your next job →',
      eta: 'ETA',
      enRoute: 'Marcus is on his way',
      notifTitle: 'Dispatch',
      notifBody: 'Marcus is 3 blocks away. Open your door! 🔧',
      notifTime: 'now',
      testimonial: '"I manage 8 apartments in Lincoln Park. Dispatch tells me the plumber is 6 minutes away before my tenant even texts me."',
      testimonialAuthor: '— Priya Nair, Landlord · Chicago',
      steps: ['Matched', 'Confirmed', 'En Route', 'Arrived', 'Done'],
      chips: [
        'Live GPS tracking',
        'Push notifications',
        'Precise ETA engine',
        'Status updates',
        'Arrival confirmation',
        'Route optimization',
      ],
    },
    pay: {
      chip: '03 / Pay',
      headline1: 'No invoice chasing.',
      headline2: 'No surprises.',
      headline3: 'No cash.',
      subtitle: 'Every job ends with a photo-verified invoice you approve before a cent is charged. Receipts go straight to your email. Landlords get consolidated monthly statements.',
      cta: 'See billing demo →',
      landlordTitle: 'For landlords & property managers',
      landlordBody: 'One dashboard. All properties. Every invoice filed by unit, category and date — ready for your accountant.',
      invoiceId: 'Invoice #DIS-INV-2891',
      invoiceDate: 'Feb 27, 2026 · 4:22 PM',
      invoiceStatus: 'Pending Approval',
      photoVerif: 'Photo verification — 3 photos attached',
      total: 'Total',
      dispute: 'Dispute',
      approve: 'Approve & Pay',
      free: 'Free',
      chips: [
        'Built-in billing',
        'Photo verification',
        'Digital receipts',
        'Split payment',
        'Card · Apple Pay · Google Pay',
        'No cash',
        'Instant pro payout',
        'Tax exports',
      ],
      lineItems: [
        { desc: 'Labor — 1.5h at $75/h', amount: '$112.50' },
        { desc: 'Replacement cartridge (OEM)', amount: '$28.00' },
        { desc: 'Travel fee', amount: '$0.00' },
      ],
    },
    rate: {
      chip: '04 / Rate',
      headline1: 'Pros earn their',
      headline2: 'next job',
      headline3: 'on this one.',
      subtitle: 'Every job is rated. Every review is verified. Pros on Dispatch show up because their livelihood depends on it — not just their weekend.',
      cta: 'Download Dispatch →',
      rateTitle: 'Rate Marcus T.',
      rateSubtitle: 'Plumbing · Feb 27, 2026 · Job #DIS-4891',
      submitBtn: 'Submit Review',
      submitted: 'Review submitted!',
      submittedSub: "Marcus\'s score updated: 4.9 ★",
      chips: [
        'Two-way reviews',
        'Verified reviews',
        'Pro accountability',
        'Quality score system',
        'Dispute resolution',
        'Badge system',
      ],
      pros: [
        { badge: 'Elite Pro', role: 'Master Plumber', tags: ['Fast', 'Neat', 'Communicative'] },
        { badge: 'Top Rated', role: 'Licensed Electrician', tags: ['Punctual', 'Thorough', 'Professional'] },
        { badge: 'Rising Star', role: 'HVAC Technician', tags: ['Detail-oriented', 'Skilled', 'Friendly'] },
      ],
    },
    testimonials: {
      headline1: 'The weekend to-do list',
      headline2: 'is no longer a crisis.',
      row1: [
        { quote: 'I booked a plumber at 7am, he was at my door by 9am. Before, I spent an hour calling around. Never again.', name: 'Jennifer Okafor', title: 'Homeowner · Brooklyn, NY' },
        { quote: "I manage 6 apartments in Logan Square. Dispatch is the only app that actually works when unit 4B has an emergency at 11pm.", name: 'David Chen', title: 'Landlord · Chicago, IL' },
        { quote: "Real-time tracking alone is worth the subscription. I know exactly when to leave the office. No more \'the tech will be there between noon and 5pm\'.", name: 'Aisha Patel', title: 'Homeowner · Los Angeles, CA' },
        { quote: 'Managing 40+ units, consolidated billing alone saves me 3 hours a month. The pros are genuinely serious.', name: 'Marcus Webb', title: 'Property Manager · New York, NY' },
      ],
      row2: [
        { quote: 'My tenant called about the AC at 8am Friday. I had a confirmed HVAC tech before 8:05. That\'s the whole concept.', name: 'Keisha Thompson', title: 'Landlord · Atlanta, GA' },
        { quote: "Photo verification before payment is brilliant. I've been burned by shoddy work before. Now I see it before I pay.", name: 'Tom Kowalski', title: 'Homeowner · Chicago, IL' },
        { quote: "Three properties, one phone. Before I had a folder of contractor business cards. Now I have Dispatch.", name: 'Fatima Al-Hassan', title: 'Real Estate Investor · Houston, TX' },
        { quote: 'An electrician arrived in 45 minutes on a Saturday. License verified, background checked. My old vendor never answered on weekends.', name: 'Ryan Nguyen', title: 'Homeowner · San Francisco, CA' },
      ],
    },
    download: {
      badge: 'Free · No credit card · No sign-up',
      headline1: 'Close the tabs.',
      headline2: 'Download Dispatch.',
      subtitle: 'One app. All licensed trades. Available today in 40+ cities. Just download — no account needed for your first booking.',
      appStoreLabel: 'Download on the',
      appStoreName: 'App Store',
      googlePlayLabel: 'Get it on',
      googlePlayName: 'Google Play',
      or: 'or',
      smsLabel: 'Get the link by SMS',
      smsPlaceholder: '+1 555 000 0000',
      smsSend: 'Send',
      smsSent: '✓ Sent!',
      smsDisclaimer: 'US numbers only · No spam · One message',
      trust: [
        { icon: '🔒', text: 'SOC 2 Type II' },
        { icon: '✓', text: 'No credit card' },
        { icon: '⭐', text: '4.9 App Store rating' },
        { icon: '🏆', text: '#1 Home Services App' },
      ],
    },
    footer: {
      book: 'Book',
      track: 'Track',
      pay: 'Pay',
      rate: 'Rate',
      downloadLink: 'Download',
      copyright: '© 2026 Dispatch Technologies, Inc.',
      privacy: 'Privacy',
      terms: 'Terms',
      support: 'Support',
    },
    mobileCta: {
      appStore: 'App Store',
      googlePlay: 'Google Play',
    },
    // Marketplace
    marketplace: {
      chip: '🛠️ Service Marketplace',
      headline1: 'Find Trusted Professionals',
      headline2: 'Near You,',
      headline3: 'Right Now',
      subtitle: 'Browse verified plumbers, electricians, cleaners and more — with real ratings, live availability, and instant booking.',
      searchPlaceholder: 'Search by name, specialty, or location…',
      categories: {
        all: 'All Services',
        plumbing: 'Plumbing',
        electrical: 'Electrical',
        cleaning: 'Cleaning',
        hvac: 'HVAC',
        carpentry: 'Carpentry',
        painting: 'Painting',
        landscaping: 'Landscaping',
        security: 'Security',
      },
      professionalsFound: 'professionals found',
      inCategory: 'in',
      availableNow: 'Available Now',
      sortTopRated: 'Top Rated',
      sortAvailable: 'Available Now',
      sortExperienced: 'Most Experienced',
      sortPriceLow: 'Price: Low to High',
      sortPriceHigh: 'Price: High to Low',
      available: 'Available',
      busy: 'Busy',
      jobs: 'Jobs',
      rate: 'Rate',
      area: 'Area',
      bookNow: 'Book Now →',
      noResults: 'No professionals found',
      noResultsSub: 'Try adjusting your search or filters',
      clearFilters: 'Clear all filters',
      ctaChip: '🚀 For Professionals',
      ctaHeadline: 'Grow Your Service Business',
      ctaSubtitle: 'Join thousands of verified professionals on Dispatch. Get more clients, manage bookings, and grow your reputation — all in one place.',
      ctaJoin: 'Join as a Professional →',
      ctaLearn: 'Learn More',
    },
    // Professional Detail
    professionalDetail: {
      backToMarketplace: 'Back to Marketplace',
      availableNow: 'Available Now',
      busy: 'Busy',
      startingRate: 'starting rate',
      reviews: 'reviews',
      tabOverview: 'Overview',
      tabReviews: 'Reviews',
      tabServices: 'Services',
      jobsDone: 'Jobs Done',
      experience: 'Experience',
      response: 'Response',
      serviceArea: 'Service Area',
      yrs: 'yrs',
      about: 'About',
      serviceHours: 'Service Hours',
      closed: 'Closed',
      servicesPriceNote: 'Common services offered — final pricing may vary based on job scope.',
      bookSession: 'Book a Session',
      nextAvailable: 'Next available:',
      bookingConfirmed: 'Booking Confirmed!',
      bookAnotherTime: 'Book Another Time',
      quickContact: 'Quick Contact',
      sendMessage: 'Send Message',
      requestCallback: 'Request Callback',
      avgResponse: 'Avg. response:',
      selectDateTime: 'Select a date & time',
      bookNowAt: 'Book Now —',
      availableTimes: 'Available times —',
      days: {
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
        Sunday: 'Sunday',
      },
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      dayNames: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    },
    // Booking Confirmation
    bookingConfirmation: {
      headline: 'Booking Confirmed!',
      subheadline: 'Your appointment has been recorded. You will receive a confirmation by email.',
      referenceLabel: 'Booking Reference',
      copy: 'Copy',
      copied: 'Copied!',
      professionalLabel: 'Your Professional',
      reviews: 'reviews',
      viewProfile: 'View profile',
      appointmentLabel: 'Appointment Details',
      serviceType: 'Service',
      dateLabel: 'Date',
      timeLabel: 'Time Slot',
      addressLabel: 'Address',
      costLabel: 'Cost Summary',
      subtotal: 'Subtotal',
      serviceFee: 'Service Fee',
      total: 'Total',
      nextStepsLabel: 'Next Steps',
      step1Title: 'Booking confirmed',
      step1Desc: 'Your request has been recorded and the professional has been notified.',
      step2Title: 'Professional confirmation',
      step2Desc: 'The professional will confirm your appointment within 30 minutes.',
      step3Title: 'Day-before reminder',
      step3Desc: 'You will receive a reminder 24 hours before your appointment.',
      step4Title: 'Service completed',
      step4Desc: 'After the service, rate your experience and leave a review.',
      contactBtn: 'Contact Pro',
      rescheduleBtn: 'Reschedule',
      contactTitle: 'Contact Marcus Johnson',
      callNow: 'Call',
      sendSms: 'Send SMS',
      smsLabel: 'Message',
      rescheduleTitle: 'Reschedule Appointment',
      rescheduleDesc: 'Choose a new time slot on the professional\'s profile.',
      rescheduleAction: 'Choose a new slot →',
      viewDashboard: 'View my dashboard',
      browseMore: 'Browse marketplace',
    },
  },

  ar: {
    nav: {
      book: 'احجز',
      track: 'تتبع',
      pay: 'ادفع',
      rate: 'قيّم',
      platform: 'المنصة',
      marketplace: 'السوق',
      services: 'الخدمات',
      delivery: 'التوصيل',
      rental: 'الإيجار',
      insurance: 'التأمين والتمويل',
      projects: 'المشاريع',
      joinPro: 'انضم كمحترف',
      adminPanel: 'لوحة الإدارة',
      professionalDashboard: 'لوحة المحترف',
      downloadApp: 'تحميل ديسباتش',
      download: 'تحميل',
    },
    hero: {
      badge: 'متاح في أكثر من 40 مدينة · أكثر من 12,000 محترف',
      headline1: 'من الصنبور',
      headline2: 'المتسرب إلى',
      headline3: 'المشكلة محلولة.',
      subtitle: 'ثلاث نقرات بين المشكلة والموعد المؤكد. سباكون وكهربائيون وعمال نظافة معتمدون — متاحون اليوم.',
      appStore: 'App Store',
      googlePlay: 'Google Play',
      stat1n: '< 60 ث',
      stat1l: 'وقت الحجز',
      stat2n: '4.9★',
      stat2l: 'متوسط تقييم المحترف',
      stat3n: 'مجاني',
      stat3l: 'بدون رسوم خدمة',
      bookingConfirmed: 'تم تأكيد الحجز',
      taskId: 'مهمة #DIS-20260227-4891',
      enRoute: 'في الطريق',
      plumber: 'سباك معتمد',
      missions: 'مهمة',
      eta: 'وقت الوصول',
      service: 'الخدمة',
      serviceVal: 'سباكة',
      slot: 'الموعد',
      slotVal: 'اليوم، 2م–4م',
      address: 'العنوان',
      addressVal: '847 W Monroe, شيكاغو',
      cost: 'التكلفة التقديرية',
      costVal: '95–140 $',
      terminalTitle: 'dispatch.js — محرك الحجز',
    },
    stats: [
      { value: '+2.4M', label: 'مهمة منجزة' },
      { value: '< 60 ث', label: 'وقت الحجز' },
      { value: '98%', label: 'الالتزام بالمواعيد' },
      { value: '+12,000', label: 'محترف معتمد' },
      { value: '4.9 ★', label: 'متوسط التقييم' },
      { value: '+40', label: 'مدينة مغطاة' },
    ],
    book: {
      chip: '01 / احجز',
      headline1: 'الطريقة القديمة كانت تستغرق',
      headline2: '40 دقيقة',
      headline3: 'و3 رسائل صوتية.',
      subtitle: 'ديسباتش يربطك بمحترف معتمد وموثق في فئتك — متاح اليوم — قبل أن تنهي قهوتك.',
      cta: 'احجز مهمتك الأولى مجاناً ←',
      appHeader: 'ماذا تحتاج؟',
      searchPlaceholder: 'صنبور متسرب تحت الحوض...',
      available: '14 سباك متاح الآن',
      earliest: 'الأقرب: اليوم الساعة 1:00 م',
      bookBtn: 'احجز ←',
      chips: [
        'مطابقة فورية',
        'توفر في الوقت الفعلي',
        'التحقق من الترخيص',
        'فحص الخلفية',
        'مواعيد في نفس اليوم',
        'الفئة: سباكة · كهرباء · تكييف · تنظيف',
        'ذكاء اصطناعي للجدولة',
        'بدون حد أدنى للالتزام',
      ],
      services: [
        { icon: '🔧', name: 'سباكة', count: '840 محترف' },
        { icon: '⚡', name: 'كهرباء', count: '620 محترف' },
        { icon: '❄️', name: 'تكييف', count: '390 محترف' },
        { icon: '🧹', name: 'تنظيف', count: '1,200 محترف' },
        { icon: '🪟', name: 'نوافذ', count: '210 محترف' },
        { icon: '🔒', name: 'أقفال', count: '180 محترف' },
      ],
    },
    track: {
      chip: '02 / تتبع',
      headline1: 'لا مزيد من',
      headline2: '"قالوا الساعة 2م"',
      headline3: 'بدون أي تحديثات.',
      subtitle: 'تتبع GPS مباشر، وقت وصول دقيق وإشعارات فورية عند كل تغيير في الحالة. ستعرف بالضبط متى تعود إلى المنزل — بالدقيقة.',
      cta: 'تتبع مهمتك القادمة ←',
      eta: 'وقت الوصول',
      enRoute: 'ماركوس في الطريق',
      notifTitle: 'ديسباتش',
      notifBody: 'ماركوس على بعد 3 مبانٍ. افتح الباب! 🔧',
      notifTime: 'الآن',
      testimonial: '"أدير 8 شقق في لينكولن بارك. ديسباتش يخبرني أن السباك سيصل خلال 6 دقائق قبل أن يرسل لي المستأجر رسالة."',
      testimonialAuthor: '— بريا ناير، مالك عقار · شيكاغو',
      steps: ['تم التطابق', 'مؤكد', 'في الطريق', 'وصل', 'منتهي'],
      chips: [
        'تتبع GPS مباشر',
        'إشعارات فورية',
        'محرك وقت وصول دقيق',
        'تحديثات الحالة',
        'تأكيد الوصول',
        'تحسين المسار',
      ],
    },
    pay: {
      chip: '03 / ادفع',
      headline1: 'لا مطاردة للفواتير.',
      headline2: 'لا مفاجآت.',
      headline3: 'لا نقود.',
      subtitle: 'تنتهي كل مهمة بفاتورة موثقة بالصور تعتمدها قبل خصم أي مبلغ. تصل الإيصالات مباشرة إلى بريدك الإلكتروني. يحصل الملاك على كشوف شهرية موحدة.',
      cta: 'شاهد عرض الفوترة ←',
      landlordTitle: 'للملاك ومديري العقارات',
      landlordBody: 'لوحة تحكم واحدة. جميع العقارات. كل فاتورة مصنفة حسب الوحدة والفئة والتاريخ — جاهزة لمحاسبك.',
      invoiceId: 'فاتورة #DIS-INV-2891',
      invoiceDate: '27 فبراير 2026 · 4:22 م',
      invoiceStatus: 'في انتظار الموافقة',
      photoVerif: 'التحقق بالصور — 3 صور مرفقة',
      total: 'الإجمالي',
      dispute: 'اعتراض',
      approve: 'موافقة ودفع',
      free: 'مجاني',
      chips: [
        'فوترة مدمجة',
        'التحقق بالصور',
        'إيصالات رقمية',
        'دفع مقسم',
        'بطاقة · Apple Pay · Google Pay',
        'بدون نقود',
        'دفع فوري للمحترف',
        'تصدير ضريبي',
      ],
      lineItems: [
        { desc: 'عمالة — 1.5 ساعة بـ 75$/ساعة', amount: '$112.50' },
        { desc: 'خرطوشة استبدال (OEM)', amount: '$28.00' },
        { desc: 'رسوم التنقل', amount: '$0.00' },
      ],
    },
    rate: {
      chip: '04 / قيّم',
      headline1: 'المحترفون يستحقون',
      headline2: 'مهمتهم القادمة',
      headline3: 'بناءً على هذه.',
      subtitle: 'كل مهمة يتم تقييمها. كل مراجعة موثقة. المحترفون في ديسباتش يحضرون لأن رزقهم يعتمد على ذلك — ليس فقط عطلة نهاية الأسبوع.',
      cta: 'تحميل ديسباتش ←',
      rateTitle: 'قيّم ماركوس ت.',
      rateSubtitle: 'سباكة · 27 فبراير 2026 · مهمة #DIS-4891',
      submitBtn: 'إرسال المراجعة',
      submitted: 'تم إرسال المراجعة!',
      submittedSub: 'تم تحديث نقاط ماركوس: 4.9 ★',
      chips: [
        'مراجعات ثنائية الاتجاه',
        'مراجعات موثقة',
        'مساءلة المحترفين',
        'نظام نقاط الجودة',
        'حل النزاعات',
        'نظام الشارات',
      ],
      pros: [
        { badge: 'محترف نخبة', role: 'سباك رئيسي', tags: ['سريع', 'دقيق', 'تواصلي'] },
        { badge: 'الأعلى تقييماً', role: 'كهربائية معتمدة', tags: ['منضبطة', 'دقيقة', 'محترفة'] },
        { badge: 'نجم صاعد', role: 'فني تكييف', tags: ['دقيق', 'ماهر', 'ودود'] },
      ],
    },
    testimonials: {
      headline1: 'قائمة مهام نهاية الأسبوع',
      headline2: 'لم تعد أزمة.',
      row1: [
        { quote: 'حجزت سباكاً الساعة 7 صباحاً، كان على بابي الساعة 9. قبل ذلك كنت أقضي ساعة في الاتصال. لن أعود لذلك أبداً.', name: 'جينيفر أوكافور', title: 'مالك منزل · بروكلين، نيويورك' },
        { quote: 'أدير 6 شقق في لوغان سكوير. ديسباتش هو التطبيق الوحيد الذي يعمل فعلاً عندما تكون هناك طوارئ في الشقة 4B الساعة 11 مساءً.', name: 'ديفيد تشن', title: 'مالك عقار · شيكاغو' },
        { quote: 'التتبع في الوقت الفعلي وحده يستحق الاشتراك. أعرف بالضبط متى أغادر المكتب. لا مزيد من "الفني سيكون هناك بين 12 و5م".', name: 'عائشة باتيل', title: 'مالك منزل · لوس أنجلوس' },
        { quote: 'بإدارة أكثر من 40 وحدة، الفوترة الموحدة وحدها توفر لي 3 ساعات شهرياً. المحترفون جادون حقاً.', name: 'ماركوس ويب', title: 'مدير عقارات · نيويورك' },
      ],
      row2: [
        { quote: 'اتصل مستأجري بشأن التكييف الساعة 8 صباح الجمعة. كان لدي فني تكييف مؤكد قبل 8:05. هذا هو المفهوم كله.', name: 'كيشا تومبسون', title: 'مالك عقار · أتلانتا' },
        { quote: 'التحقق بالصور قبل الدفع رائع. لقد خُدعت من قبل بعمل رديء. الآن أرى قبل أن أدفع.', name: 'توم كوالسكي', title: 'مالك منزل · شيكاغو' },
        { quote: 'ثلاث عقارات، هاتف واحد. قبل ذلك كان لدي ملف من بطاقات أعمال المقاولين. الآن لدي ديسباتش.', name: 'فاطمة الحسن', title: 'مستثمر عقاري · هيوستن' },
        { quote: 'وصل كهربائي في 45 دقيقة يوم السبت. ترخيص موثق، خلفية مفحوصة. مزودي القديم لم يكن يرد أبداً في عطلة نهاية الأسبوع.', name: 'ريان نغوين', title: 'مالك منزل · سان فرانسيسكو' },
      ],
    },
    download: {
      badge: 'مجاني · بدون بطاقة ائتمان · بدون تسجيل',
      headline1: 'أغلق التبويبات.',
      headline2: 'حمّل ديسباتش.',
      subtitle: 'تطبيق واحد. جميع المهن المرخصة. متاح اليوم في أكثر من 40 مدينة. فقط حمّل — لا حساب مطلوب لحجزك الأول.',
      appStoreLabel: 'تحميل من',
      appStoreName: 'App Store',
      googlePlayLabel: 'متاح على',
      googlePlayName: 'Google Play',
      or: 'أو',
      smsLabel: 'احصل على الرابط عبر SMS',
      smsPlaceholder: '+966 5X XXX XXXX',
      smsSend: 'إرسال',
      smsSent: '✓ تم الإرسال!',
      smsDisclaimer: 'أرقام محلية فقط · بدون بريد مزعج · رسالة واحدة',
      trust: [
        { icon: '🔒', text: 'SOC 2 Type II' },
        { icon: '✓', text: 'بدون بطاقة ائتمان' },
        { icon: '⭐', text: 'تقييم 4.9 في App Store' },
        { icon: '🏆', text: '#1 تطبيق خدمات منزلية' },
      ],
    },
    footer: {
      book: 'احجز',
      track: 'تتبع',
      pay: 'ادفع',
      rate: 'قيّم',
      downloadLink: 'تحميل',
      copyright: '© 2026 Dispatch Technologies, Inc.',
      privacy: 'الخصوصية',
      terms: 'الشروط',
      support: 'الدعم',
    },
    mobileCta: {
      appStore: 'App Store',
      googlePlay: 'Google Play',
    },
    // Marketplace
    marketplace: {
      chip: '🛠️ سوق الخدمات',
      headline1: 'ابحث عن محترفين موثوقين',
      headline2: 'بالقرب منك،',
      headline3: 'الآن',
      subtitle: 'تصفح سباكين وكهربائيين وعمال نظافة وأكثر — مع تقييمات حقيقية وتوفر مباشر وحجز فوري.',
      searchPlaceholder: 'ابحث بالاسم أو التخصص أو الموقع…',
      categories: {
        all: 'جميع الخدمات',
        plumbing: 'سباكة',
        electrical: 'كهرباء',
        cleaning: 'تنظيف',
        hvac: 'تكييف',
        carpentry: 'نجارة',
        painting: 'دهان',
        landscaping: 'تنسيق حدائق',
        security: 'أمن',
      },
      professionalsFound: 'محترف موجود',
      inCategory: 'في',
      availableNow: 'متاح الآن',
      sortTopRated: 'الأعلى تقييماً',
      sortAvailable: 'متاح الآن',
      sortExperienced: 'الأكثر خبرة',
      sortPriceLow: 'السعر: من الأقل',
      sortPriceHigh: 'السعر: من الأعلى',
      available: 'متاح',
      busy: 'مشغول',
      jobs: 'مهام',
      rate: 'السعر',
      area: 'المنطقة',
      bookNow: 'احجز الآن ←',
      noResults: 'لم يتم العثور على محترفين',
      noResultsSub: 'حاول تعديل بحثك أو الفلاتر',
      clearFilters: 'مسح جميع الفلاتر',
      ctaChip: '🚀 للمحترفين',
      ctaHeadline: 'طوّر نشاطك التجاري',
      ctaSubtitle: 'انضم إلى آلاف المحترفين الموثقين على ديسباتش. احصل على المزيد من العملاء وأدر حجوزاتك وطوّر سمعتك — كل ذلك في مكان واحد.',
      ctaJoin: 'انضم كمحترف ←',
      ctaLearn: 'اعرف المزيد',
    },
    // Professional Detail
    professionalDetail: {
      backToMarketplace: 'العودة إلى السوق',
      availableNow: 'متاح الآن',
      busy: 'مشغول',
      startingRate: 'السعر الابتدائي',
      reviews: 'تقييم',
      tabOverview: 'نظرة عامة',
      tabReviews: 'التقييمات',
      tabServices: 'الخدمات',
      jobsDone: 'المهام',
      experience: 'الخبرة',
      response: 'الاستجابة',
      serviceArea: 'منطقة الخدمة',
      yrs: 'سنة',
      about: 'عن',
      serviceHours: 'ساعات الخدمة',
      closed: 'مغلق',
      servicesPriceNote: 'الخدمات الشائعة المقدمة — قد يختلف السعر النهائي حسب نطاق العمل.',
      bookSession: 'احجز جلسة',
      nextAvailable: 'الموعد التالي:',
      bookingConfirmed: 'تم تأكيد الحجز!',
      bookAnotherTime: 'احجز وقتاً آخر',
      quickContact: 'تواصل سريع',
      sendMessage: 'إرسال رسالة',
      requestCallback: 'طلب معاودة الاتصال',
      avgResponse: 'متوسط وقت الاستجابة:',
      selectDateTime: 'اختر تاريخاً ووقتاً',
      bookNowAt: 'احجز الآن —',
      availableTimes: 'الأوقات المتاحة —',
      days: {
        Monday: 'الاثنين',
        Tuesday: 'الثلاثاء',
        Wednesday: 'الأربعاء',
        Thursday: 'الخميس',
        Friday: 'الجمعة',
        Saturday: 'السبت',
        Sunday: 'الأحد',
      },
      months: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
      dayNames: ['أح', 'إث', 'ثل', 'أر', 'خم', 'جم', 'سب'],
    },
    // Booking Confirmation
    bookingConfirmation: {
      headline: 'تم تأكيد الحجز!',
      subheadline: 'تم تسجيل موعدك. ستتلقى تأكيداً عبر البريد الإلكتروني.',
      referenceLabel: 'رقم مرجع الحجز',
      copy: 'نسخ',
      copied: 'تم النسخ!',
      professionalLabel: 'محترفك',
      reviews: 'تقييم',
      viewProfile: 'عرض الملف الشخصي',
      appointmentLabel: 'تفاصيل الموعد',
      serviceType: 'الخدمة',
      dateLabel: 'التاريخ',
      timeLabel: 'الفترة الزمنية',
      addressLabel: 'العنوان',
      costLabel: 'ملخص التكلفة',
      subtotal: 'المجموع الفرعي',
      serviceFee: 'رسوم الخدمة',
      total: 'الإجمالي',
      nextStepsLabel: 'الخطوات التالية',
      step1Title: 'تم تأكيد الحجز',
      step1Desc: 'تم تسجيل طلبك وإخطار المحترف.',
      step2Title: 'تأكيد المحترف',
      step2Desc: 'سيؤكد المحترف موعدك خلال 30 دقيقة.',
      step3Title: 'تذكير قبل يوم',
      step3Desc: 'ستتلقى تذكيراً قبل 24 ساعة من موعدك.',
      step4Title: 'اكتمال الخدمة',
      step4Desc: 'بعد الخدمة، قيّم تجربتك واترك مراجعة.',
      contactBtn: 'تواصل مع المحترف',
      rescheduleBtn: 'إعادة الجدولة',
      contactTitle: 'تواصل مع Marcus Johnson',
      callNow: 'اتصل',
      sendSms: 'إرسال رسالة',
      smsLabel: 'رسالة',
      rescheduleTitle: 'إعادة جدولة الموعد',
      rescheduleDesc: 'اختر فترة زمنية جديدة من ملف المحترف.',
      rescheduleAction: 'اختر فترة جديدة ←',
      viewDashboard: 'عرض لوحة التحكم',
      browseMore: 'تصفح السوق',
    },
  },
};

export function getTranslations(lang: Language) {
  return translations[lang] ?? translations['fr'];
}
